/* global Blockly */
import React from 'react';

const BLOCK_NAME = 'snap_wait';
const PROMISES_EXECUTION_STRING = "BlocklyPromises.length && ExecutionRuntimeModule.Execute(BlocklyPromises);";

function registerSnapWaitBlock() {
    Blockly.Blocks[BLOCK_NAME] = {
        init: function() {
            const durationField = new Blockly.FieldNumber(0, 0);
            this.appendDummyInput()
                .appendField("wait for ")
                .appendField(durationField, "DURATION")
                .appendField("(s) then do");
            this.appendStatementInput("CALLBACK")
                .setCheck(null);
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.LOGIC_HUE);
            this.setTooltip('Wait for some seconds then execute a statement.');
            this.setHelpUrl(Blockly.BASE_HELP_URL+"#logic");
        }
    };

    Blockly.JavaScript[BLOCK_NAME] = function(block) {
        let duration = block.getFieldValue('DURATION');
        let statements_callback = Blockly.JavaScript.statementToCode(block, 'CALLBACK');
        let code = '' +
            'setTimeout(function(){' +
            statements_callback +
            PROMISES_EXECUTION_STRING +
            '},' + duration*1000 + ');\n';
        return code;
    };
}

const SnapWait = function () {
    SnapWait.blockName = BLOCK_NAME;

    registerSnapWaitBlock();

    return (
        <block type={BLOCK_NAME}></block> /* NOSONAR */
    );
};

export default SnapWait;